// App.js
import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { logPageView } from './analytics';
import ConditionDUtilisation from './components/ConditionsDUtilisations';
import Home from './components/Home/Home';
import MemberPage from './components/MemberPage/MemberPage';
import MentionLegales from './components/MentionLegales';
import MentionsLegalesApp from './components/MentionsLegalesApp';
import Navbar from './components/Navbar';
import OurEngagement from './components/OurEngagement/OurEngagement';
import './styles/fonts.css';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    setIsAdmin(!!token);
  }, []);

  const handleLogout = () => {
    setIsAdmin(false);
    localStorage.removeItem('adminToken');
  };

  return (
    <>
      {isAdmin && (
        <Box
          sx={{
            position: 'fixed', top: 0, width: '100%',
            bgcolor: '#388E3C', color: 'white',
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', p: 1, zIndex: 1300,
          }}
        >
          <Typography variant="body2">Connecté en tant qu'admin</Typography>
          <Button onClick={handleLogout} color="inherit" size="small">
            Se déconnecter
          </Button>
        </Box>
      )}

      <Box sx={{ mt: isAdmin ? '40px' : 0 }}>
        <Navbar isAdmin={isAdmin} />
        <Routes>

          {/* <Route path="/" element={<SearchFood />} /> */}
          {/* <Route path="/catalogue" element={<SearchFood />} /> */}
          {/* <Route path="/actualites" element={<NewsPage isAdmin={isAdmin} />} /> */}
          {/* <Route path="/actualites/:slug" element={<NewsDetailsPage />} /> */}
          {/* <Route path="/admin-login" element={<AdminLogin />} /> */}
          <Route path="/notre-engagement" element={<OurEngagement />} />
          <Route path="/espace-membres" element={<MemberPage />} />
          <Route path="/" element={<Home />} />
          <Route path="/application" element={<Home />} />
          <Route path="/condition-d-utilisation" element={<ConditionDUtilisation />} />
          <Route path="/mentions-legales" element={<MentionLegales />} />
          <Route path="/mentions-legales-app" element={<MentionsLegalesApp />} />
        </Routes>
      </Box>
    </>
  );
}

export default App;